import NiceModal, { useModal } from "@ebay/nice-modal-react";
import PopupMask from "@/componentsUI/PopupMask";
import useDialogManager from "@/utils/useDialogManager";
import React, { useEffect, useRef, useState } from "react";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import { useNavigate } from "react-router";
import { sys } from "@/Core/utils/system";
import { useGlobalState } from "@/store/commonStore";
import { useUserInfo } from "@/store/userInfo";
import useScreenDesign from "@/Core/utils/hooks/useScreenDesign";
import styles from "./ActivityPopup.module.less";
import { useCheckIn, useCheckIn7Days } from "./useActivityPopupList";
import MarketingImagePopup from "@/features/common/marketingPopup";
import ButtonUI from "@/componentsUI/Button";
import { feedback } from "@/utils/feedback";
import { useDispatch } from "react-redux";
import { cancelQueuedP20Tasks } from "@/features/modalOrchestrator/modalOrchestratorSlice";

const ActivityPopup = NiceModal.create((props: any) => {
  const { popList = [] } = props || {};
  const dispatch = useDispatch();
  const { t } = useTranslationPlus();
  const [index, setIndex] = useState(0);
  const [detail, setDetail] = useState<any>();
  const [visible, setVisible] = useState(true);
  const tweenOverRef = useRef<boolean>(true);
  const { data: userInfo } = useUserInfo();
  const { isLogin } = useGlobalState();
  const {
    openSignIn,
    openSignUp,
    openWallet,
    openVip,
    openSharePage,
    openTaskCenter,
    openWheel,
    openBetting,
    openFarm,
  } = useDialogManager();
  const { visible: modalVisible, remove, resolve } = useModal();
  const navigate = useNavigate();
  const [checkedBox, setCheckedBox] = useState<boolean>(false);
  const isMobile = useScreenDesign();
  const { trigger: checkIn7DaysTrigger } = useCheckIn7Days();
  const { trigger: checkInTrigger } = useCheckIn();

  useEffect(() => {
    if (popList.length) {
      if (isMobile) {
        setDetail(popList[index]);
      } else {
        setDetail(popList[index]);
      }
      setVisible(true);
    }
  }, [index, popList]);

  const nextPopup = () => {
    console.log("nextPopup");
    if (tweenOverRef.current) {
      setCheckedBox(false);
      const nextIndex = index + 1;
      if (nextIndex >= popList.length) {
        console.log('"nextIndex >= popList.length"');
        resolve();
        remove();
      } else {
        console.log("nextIndex", nextIndex);
        setIndex(nextIndex);
      }
      tweenOverRef.current = false;
      setTimeout(() => {
        tweenOverRef.current = true;
      }, 10);
    }
  };

  // 用户主动进入业务时结束本轮剩余营销，避免后续邀请覆盖钱包。
  const closeAllPopups = () => {
    if (tweenOverRef.current) {
      dispatch(cancelQueuedP20Tasks());
      setCheckedBox(false);
      resolve();
      remove();
      tweenOverRef.current = false;
    }
  };

  const onCheckInChange = (checked) => {
    setCheckedBox(checked);
    const key = `today-nopop-${isLogin ? userInfo?.userId : ""}-${detail.id}`;
    if (checked) {
      localStorage.setItem(
        key,
        JSON.stringify(new Date().toLocaleDateString())
      );
    } else {
      localStorage.removeItem(key);
    }
  };
  const handleCheckIn = async (activityType: number) => {
    try {
      await (activityType === 8 ? checkIn7DaysTrigger() : checkInTrigger());
    } catch (error) {
      feedback.error(t(error?.code || (activityType === 8 ? "ERROR_CHECK7DAY" : "ERROR_999")));
    }
  };

  //跳转到游戏界面
  const handleJumpGame = (id) => {
    if (!isLogin) {
      openSignIn();
    } else {
      navigate(`/game/${id}`);
      closeAllPopups();
    }
  };

  //跳转到活动详情
  const handleJumpActivity = (id) => {
    navigate(`/ActivityDetails/${id}`);
    closeAllPopups();
  };

  //跳转链接
  const handleJumpLink = (link) => {
    if (link?.startsWith("http")) {
      sys.openUrl(link);
    } else {
      sys.openUrl(`https://${link}`);
    }
    closeAllPopups();
  };

  //跳转内部页面  匹配路由
  const handleInnerPage = (type) => {
    if (!isLogin) {
      openSignIn();
      return;
    }
    navigate(type);
    closeAllPopups();
  };

  // 跳转内部弹窗
  const handleModalPage = (type) => {
    if (!isLogin) {
      openSignIn();
      return;
    }
    switch (type) {
      case "1":
        openWallet();
        break;
      case "2":
        openVip();
        break;
      case "3":
        openSharePage();
        break;
      case "4":
        openTaskCenter();
        break;
      case "5":
        openWheel();
        break;
      case "6":
        openBetting();
        break;
      case "7":
        openFarm();
        break;
      default:
        console.error("没有匹配对应类型");
        break;
    }
    closeAllPopups();
  };

  // 5内部弹窗  6内部界面
  const handleCardMapFunction = new Map([
    [2, handleJumpGame],
    [3, handleJumpActivity],
    [4, handleJumpLink],
    [5, handleModalPage],
    [6, handleInnerPage],
  ]);

  const clickCard = () => {
    if (!tweenOverRef.current) return;
    console.log("clickCard");
    const { activityType, jumpType, jumpTo } = detail;
    if (activityType == 8 || activityType == 6) {
      if (!isLogin) {
        openSignIn();
        return;
      }
      void handleCheckIn(Number(activityType));
      closeAllPopups(); // 签到后关闭所有弹窗
    } else if (jumpType && handleCardMapFunction.has(jumpType)) {
      // 处理跳转，并结束所有弹窗
      handleCardMapFunction.get(jumpType)?.call(this, jumpTo);
    } else {
      // 如果没有跳转类型，也关闭所有弹窗
      closeAllPopups();
    }
  };

  if (!modalVisible || !visible) {
    return null;
  }

  return (
    <PopupMask visible={modalVisible}>
      <div className={styles.wrapper}>
        {detail ? (
          <MarketingImagePopup
            imageSrc={
              isMobile ? detail?.customPic || detail?.popPic : detail?.popPic
            }
            imageAlt="Activity"
            onImageClick={() => {
              // 点击普通活动弹窗内容时关闭整个弹窗队列
              clickCard();
            }}
            onClose={() => {
              // 点击关闭按钮显示下一个弹窗
              nextPopup();
            }}
            imageClassName={styles.image}
            footer={
              detail.activityType === 6 ? (
                <ButtonUI
                  type="primary"
                  className={styles.checkInBtn}
                  onClick={() => {
                    clickCard();
                  }}
                >
                  {t("Check-in")}
                </ButtonUI>
              ) : null
            }
          />
        ) : (
          <div className={styles.loading}>
            <div className={styles.loadingImage} />
            <div className={styles.loadingLine} />
            <div className={styles.loadingLine} />
            <div className={styles.loadingLineShort} />
          </div>
        )}
      </div>
    </PopupMask>
  );
});

export default ActivityPopup;
